import _ from 'lodash';
import countryDb from '@cores/constants/country';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export const name = 'COUNTRY.render';
const getFamilyCountry = type => {
    if (type === 'SIMPLE_FAMILY_COUNTRY')
        return 'simple';
    if (type === 'EFAM_COUNTRY')
        return 'extend';
    return type;
};
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const { PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    const familyType = getFamilyCountry(prop);
    const countries = _.map(cellValue, content => {
        const countryName = _.get(countryDb, `${content}.${this.$i18n.locale}`, '');
        return (<span data-link-type="patentFamily" data-family-country={content} data-custom-family-type={familyType} data-patent-id={PATENT_ID} data-patent-no={PN} data-origin-field-name={prop}>
                <span class={`flag-authority flag-authority--${content}`}/>
                {/* @ts-ignore */}
                <span class="flag-authority__label" domProps={{ innerHTML: _highlightMixin_hlText(countryName) }}/>
            </span>);
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {countries}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const i18n = injectService(i18nSymbol);
    const result = _.map(row[column.property] || [], country => {
        return _.get(countryDb, `${country}.${i18n.locale}`, '');
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
